/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsLinksOptions } from './FxIdDomainSettingsLinksOptions';
import {
    instanceOfFxIdDomainSettingsLinksOptions,
    FxIdDomainSettingsLinksOptionsFromJSON,
    FxIdDomainSettingsLinksOptionsFromJSONTyped,
    FxIdDomainSettingsLinksOptionsToJSON,
} from './FxIdDomainSettingsLinksOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsLinks
 * Публичные настройки для разнообразных ссылок
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsLinks = FxIdDomainSettingsLinksOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsLinksFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLinks {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLinksFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsLinks {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsLinksOptions(json)) {
        return FxIdDomainSettingsLinksOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLinksToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLinksToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLinksToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsLinksOptions(value)) {
        return FxIdDomainSettingsLinksOptionsToJSON(value as FxIdDomainSettingsLinksOptions);
    }

    return {};
}

